// src/pages/About.jsx
import React from 'react';

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white">
      <h1 className="text-3xl font-bold text-blue-200 mb-4">About</h1>
      <p className="text-gray-300">
        This site is built for students, hobbyists, and professionals in electrical engineering who want quick access to useful calculators and converters.
        Whether you're analyzing circuits or working on a real-world project, our tools are here to help you get answers fast.
      </p>
    </div>
  );
}